import { Observable } from 'rxjs/Observable';
import {AsyncValidatorFn, AbstractControl } from '@angular/forms';
import { Injectable} from '@angular/core';
import {timer} from 'rxjs/observable/timer';
import {map, switchMap, catchError, tap} from 'rxjs/operators';
import { ProgramService } from './services/program/program.service';
import { CreateStudent } from './interfaces/requests/create-student';
import { throwError, of } from 'rxjs';

@Injectable()
export class UserValidators {
  constructor(private programService: ProgramService) {}

  searchUserByLogin(data) {
    return timer(1000)
      .pipe(
        switchMap(() => {
          return this.programService.validateUserName(data);
        })
      );
  }

  uniqueLoginValidator(): AsyncValidatorFn {
    return (control: AbstractControl): any => {
        return this.searchUserByLogin(control.value).pipe(
          catchError(err => {
            if (err.error.errors && err.error.errors.loginName) {
              return of({ userNameError: err.error.errors.loginName[0]});
            } else {
              return of({userNameError: null});
            }
          }),
          map((res: any) => {
            if (res.userNameError) {
              return res;
            } else {
              return null;
            }
          })
        );
    };
  }

}
